export const ICON_SIZE = {
    medium: 'medium',
    big: 'big',
    bigDesktop: 'bigDesktop',
} as const
